export default {
  namespace: 'ProjectCooperation',
  translations: {
    zh: {
      hero: {
        kicker: 'PROJECT COOPERATION',
        title: '项目合作',
        description: '围绕联合开发、场景共创、资源协同与落地推进，未来世界为企业与机构提供更灵活、更可执行的合作方式。'
      },
      switcher: {
        label: 'COOPERATION MENU',
        title: '选择合作主题'
      },
      overview: {
        label: 'OVERVIEW',
        title: '合作说明'
      },
      content: {
        label: 'COOPERATION ITEMS',
        title: '合作内容'
      },
      questionnaire: {
        label: 'QUESTIONNAIRE',
        title: '二维码问卷',
        description: '后台可按语言发布问卷标题、说明与二维码图片，前台会随当前内容同步切换。',
        qrLabel: '问卷二维码',
        qrEmpty: '暂未上传二维码'
      },
      meta: {
        publishedAt: '发布时间'
      },
      status: {
        loading: '项目合作内容加载中...',
        emptyTitle: '暂未发布合作内容',
        emptyDescription: '当前语言下还没有已发布的合作信息，请稍后再来看看。',
        errorTitle: '合作内容加载失败',
        errorDescription: '当前无法读取项目合作数据，请稍后重试。'
      }
    },
    en: {
      hero: {
        kicker: 'PROJECT COOPERATION',
        title: 'Project Cooperation',
        description: 'Future World supports companies and institutions with flexible, execution-focused cooperation models across joint development, scenario co-creation, resource coordination, and implementation.'
      },
      switcher: {
        label: 'COOPERATION MENU',
        title: 'Choose a cooperation track'
      },
      overview: {
        label: 'OVERVIEW',
        title: 'Cooperation Overview'
      },
      content: {
        label: 'COOPERATION ITEMS',
        title: 'What We Can Co-build'
      },
      questionnaire: {
        label: 'QUESTIONNAIRE',
        title: 'QR Survey',
        description: 'The title, description, and QR asset can all be published per language from the backend.',
        qrLabel: 'Survey QR Code',
        qrEmpty: 'QR code not uploaded yet'
      },
      meta: {
        publishedAt: 'Published'
      },
      status: {
        loading: 'Loading project cooperation content...',
        emptyTitle: 'No published cooperation content yet',
        emptyDescription: 'There is no published project cooperation content in the current language right now.',
        errorTitle: 'Failed to load cooperation content',
        errorDescription: 'The cooperation content is temporarily unavailable. Please try again later.'
      }
    },
    ja: {
      hero: {
        kicker: 'PROJECT COOPERATION',
        title: 'プロジェクト協業',
        description: 'Future World は、共同開発、シナリオ共創、リソース連携、実装推進までを含む柔軟で実行志向の協業モデルを提供します。'
      },
      switcher: {
        label: 'COOPERATION MENU',
        title: '協業テーマを選ぶ'
      },
      overview: {
        label: 'OVERVIEW',
        title: '協業概要'
      },
      content: {
        label: 'COOPERATION ITEMS',
        title: '協業内容'
      },
      questionnaire: {
        label: 'QUESTIONNAIRE',
        title: 'QRアンケート',
        description: 'アンケートのタイトル、説明、QR画像は言語ごとに管理画面から公開できます。',
        qrLabel: 'アンケートQRコード',
        qrEmpty: 'QRコードはまだ登録されていません'
      },
      meta: {
        publishedAt: '公開日'
      },
      status: {
        loading: 'プロジェクト協業コンテンツを読み込み中...',
        emptyTitle: '公開中の協業コンテンツはありません',
        emptyDescription: '現在の言語では公開中のプロジェクト協業情報がまだありません。',
        errorTitle: '協業コンテンツの読み込みに失敗しました',
        errorDescription: '現在、プロジェクト協業データを取得できません。後でもう一度お試しください。'
      }
    }
  }
};
